export const fromConfig = {
    dialogAttr: {
        title: '新增',
        width: '80%'
    },
    dialogFooter: true,
    fromComponent: {
        labelWidth: '80px',
        component: [
            {
                component: 'el-input',
                prop: 'sceneName',
                name: '场景名称',
                span: 12,
                // width: '40%',
                useAttr: {
                    placeholder: '请选择场景名称',
                    maxlength: 64,
                    clearable: true
                }
            }, {
                component: 'el-select',
                prop: 'sourceSys',
                name: '来源系统',
                span: 12,
                relevance: ['scanSys', 'operateType', 'invokeMethod'],
                width: '100%',
                useAttr: {
                    placeholder: '请选择来源系统',
                    multiple: true,
                    collapseTags: true,
                    filterable: true,
                    clearable: true
                },
                chiType: 'el-option',
                options: []
            }, {
                component: 'el-select',
                prop: 'scanSys',
                width: '100%',
                name: '扫码系统',
                span: 12,
                useAttr: {
                    placeholder: '请选择扫码系统',
                    multiple: true,
                    collapseTags: true,
                    disabled: true,
                    clearable: true
                },
                chiType: 'el-option',
                options: []
            }, {
                component: 'el-select',
                prop: 'invokeMethod',
                name: '调用方式',
                width: '100%',
                span: 12,
                useAttr: {
                    placeholder: '请选择调用方式',
                    disabled: true,
                    clearable: true
                },
                chiType: 'el-option',
                options: []
            }, {
                component: 'el-select',
                prop: 'operateType',
                name: '操作类型',
                width: '100%',
                span: 12,
                useAttr: {
                    placeholder: '请选择操作类型',
                    disabled: true,
                    clearable: true
                },
                chiType: 'el-option',
                options: []
            },
            {
                component: 'el-input',
                prop: 'remark',
                span: 12,
                name: '备注',
                useAttr: {
                    placeholder: '请输入备注',
                    maxlength: 256,
                    clearable: true
                }
            }
        ],
        // 插槽自定义
        slotComponent: [
            {
                slotName: 'mTable',
                prop: 'stepDtoList',
                width: '0px'
            }
        ],
        rules: {
            sceneName: [
                { required: true, message: '请选择场景名称', trigger: 'blur' }
            ]
            // sourceSys: [
            //     { required: true, message: '请选择来源系统', trigger: 'change' }
            // ],
            // scanSys: [
            //     { required: true, message: '请选择扫码系统', trigger: 'change' }
            // ],
            // operateType: [
            //     { required: true, message: '请选择操作类型', trigger: 'change' }
            // ],
            // invokeMethod: [
            //     { required: true, message: '请选择调用方式', trigger: 'change' }
            // ]
        }
    }

};
